import React from 'react';
import moment from 'moment';
import * as S from './style';
import { FormStatusInfo, Label, Btn } from 'components';
import { ReactComponent as ImgInterviewNotice } from 'assets/img/status/img_interview_notice.svg';

interface Props {
  serviceType: string;
  interviewDate?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function InterviewAnswer({
  serviceType,
  interviewDate,
  onClick,
}: Props): React.ReactElement {
  return serviceType === 'move_cleaning' ? (
    <FormStatusInfo
      title={['인터뷰 참여신청 완료']}
      subTitle={['인터뷰 예상일']}
      image={<ImgInterviewNotice />}
      inHomeBtn={true}
    >
      <S.DateWrapper>
        <Label
          fontStyle={'h4'}
          color={'blue_900'}
          contents={
            interviewDate
              ? moment(interviewDate).format('YYYY년 MM월 DD일')
              : '-'
          }
        />
      </S.DateWrapper>
      <S.CaptionWrapper>
        {[
          '감사합니다. 인터뷰 예상일에 연락을 드리며 인터뷰 시간은 30분 정도 소요됩니다.',
        ].map((item, index) => (
          <Label
            key={index}
            contents={item}
            color={'gray_opacity_600'}
            fontStyle={'body2'}
          />
        ))}
      </S.CaptionWrapper>
    </FormStatusInfo>
  ) : (
    <FormStatusInfo
      title={['인터뷰 참여신청 완료']}
      subTitle={['인터뷰 예상일']}
      image={<ImgInterviewNotice />}
      btnWidth={180}
      btn={
        <Btn
          height={44}
          fontStyle={'body2'}
          backGroundColor={'blue_opacity_100'}
          color={'blue_900'}
          onClick={onClick}
        >
          {'짐싸 파트너 사용법'}
        </Btn>
      }
      inHomeBtn={true}
    >
      <S.DateWrapper>
        <Label
          fontStyle={'h4'}
          color={'blue_900'}
          contents={
            interviewDate
              ? moment(interviewDate).format('YYYY년 MM월 DD일')
              : '-'
          }
        />
      </S.DateWrapper>
      <S.CaptionWrapper>
        {[
          '감사합니다. 인터뷰 예상일에 연락을 드리며 인터뷰 시간은 30분 정도 소요됩니다.',
        ].map((item, index) => (
          <Label
            key={index}
            contents={item}
            color={'gray_opacity_600'}
            fontStyle={'body2'}
          />
        ))}
      </S.CaptionWrapper>
    </FormStatusInfo>
  );
}

export default InterviewAnswer;
